import { atom } from "jotai";

export const clientFiltersAtom = atom<any>({
  dataType: "Sum",
  dateType: "Last 7 Days",
});
